import React from 'react';
import { Group } from 'src/design/atoms/Group';
import { useNavigate } from 'react-router-dom';
import { RfiDto } from 'src/api/FiretrolApiClient';
import { useAuth } from 'src/hooks/useAuth';
import { useJobs } from 'src/hooks/useJobs';
import { SecondaryButton } from 'src/design/atoms/SecondaryButton';
import { Header } from 'src/design/organisms/Header';
import { jobBreadcrumbs } from 'src/app/workflows/jobBreadcrumbs';
import { RFIForm } from 'src/routes/Jobs/RFIs/components/RFIForm';

const emptyRFI: RfiDto = {
  id: '00000000-0000-0000-0000-000000000000',
  rfiId: 0,
  needDate: new Date(),
  rfiNumber: '',
  status: '',
  stepIndex: -1,
  externalRfiNumber: '',
  workflowId: 0,
  from: '',
  fromUserId: 1,
  fromCompany: '',
  reporterUserId: -1,
  submittedOn: new Date(),
  question: '',
  slug: '',
  recommendation: '',
  impact: 'tbd',
  costDollars: '',
  costDays: '',
  impactNotes: '',
  attachments: [],
  responseAttachments: [],
  history: [],
  workflow: undefined,
  responseToImpacts: '',
  responseToQuestions: '',
  responseFrom: '',
  responseDate: new Date(),
  externalContact: undefined,
  submittedToContactId: undefined,
  attentionContactId: undefined,
};

export const SubmitRFI: React.FC = () => {
  const { selectedJob } = useJobs();
  const { user } = useAuth();
  const navigate = useNavigate();
  const initialValues = React.useMemo((): RfiDto => {
    return {
      ...emptyRFI,
      workflowId: selectedJob ? selectedJob.rfiWorkflowId : 0,
      workflow: selectedJob?.rfiWorkflow ?? undefined,
      reporterUserId: user?.id || -1,
      fromUserId: user?.id || -1,
      fromCompany: user?.companyName || '',
    };
  }, [selectedJob?.rfiWorkflow, user?.id]);
  if (!selectedJob) return null;
  return (
    <>
      <Header
        breadcrumbProps={{
          items: jobBreadcrumbs(
            selectedJob,
            { text: 'RFIs', href: `/jobs/${selectedJob.id}/rfis` },
            'Submit RFI',
          ),
        }}
        title="Submit RFI"
        helpText="Create a new Request for Information (RFI) for this job."
      />
      <Group justify="flex-end" mb="md">
        <SecondaryButton
          onClick={() => navigate(`/jobs/${selectedJob.id}/rfis`)}
        >
          Cancel
        </SecondaryButton>
      </Group>
      <RFIForm
        selectedJob={selectedJob}
        onSaved={(rfi) => navigate(`/jobs/${selectedJob.id}/rfis/${rfi.id}`)}
        initialValues={initialValues}
      />
    </>
  );
};
